import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import EmployeesPage from './pages/EmployeesPage';
import EmployeeDetailPage from './pages/EmployeeDetailPage';
import AttendancePage from './pages/AttendancePage';
import LeavePage from './pages/LeavePage';
import PayrollPage from './pages/PayrollPage';
import PayrollDetailPage from './pages/PayrollDetailPage';
import DepartmentsPage from './pages/DepartmentsPage';
import DepartmentDetailPage from './pages/DepartmentDetailPage';
import PositionsPage from './pages/PositionsPage';
import PositionDetailPage from './pages/PositionDetailPage';
import CampaignsPage from './pages/CampaignsPage';
import CampaignDetailPage from './pages/CampaignDetailPage';
import EmployeeTasksPage from './pages/EmployeeTasksPage';
import UserManagementPage from './pages/UserManagementPage';
import ReportsPage from './pages/ReportsPage';

const PrivateRoute = ({ children, roles }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<DashboardPage />} />
            <Route path="employees" element={<EmployeesPage />} />
            <Route path="employees/:id/:slug" element={<EmployeeDetailPage />} />
            <Route path="departments" element={<DepartmentsPage />} />
            <Route path="departments/:id/:slug" element={<DepartmentDetailPage />} />
            <Route path="positions" element={<PositionsPage />} />
            <Route path="positions/:id/:slug" element={<PositionDetailPage />} />
            <Route path="campaigns" element={<CampaignsPage />} />
            <Route path="campaigns/:id/:slug" element={<CampaignDetailPage />} />
            <Route path="tasks" element={<EmployeeTasksPage />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="users" element={
              <PrivateRoute roles={['admin']}>
                <UserManagementPage />
              </PrivateRoute>
            } />
            <Route path="attendance" element={<AttendancePage />} />
            <Route path="leave" element={<LeavePage />} />
            <Route path="payroll" element={
              <PrivateRoute roles={['admin','hr_manager']}>
                <PayrollPage />
              </PrivateRoute>
            } />
            <Route path="payroll/:id" element={
              <PrivateRoute roles={['admin','hr_manager']}>
                <PayrollDetailPage />
              </PrivateRoute>
            } />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
